/**
 * Created by Daniel Wang on 2/25/2024.
 * Description: Component for add/edit web sites
 * ------ maintenance history ------
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UntypedFormControl } from '@angular/forms';
import { AppState } from '../../../../../redux';
import * as _lodash from 'lodash';

import { SlideSheetService } from '../../../../../services/slide-sheet.service';
import { SlideSheetActionTypes } from '../../../../slide-sheet/slide-sheet.model';
import { AdminPageActionTypes } from '../../../../../redux/actions/admin-page.actions';
import { adminSharedPageConstants } from '../../../admin-page-setting.constants';
import { IdHelperService } from '../../../../../services/id-helper.service';
import { WebSiteDialogAttributes, WebSites } from '../../../../../tamalelibs/models/admin-page.model';

@Component({
    selector: 'tam-web-sites-editor',
    templateUrl: './web-sites-editor.component.html',
    styleUrls: ['./web-sites-editor.component.scss']
})
export class WebSitesEditorComponent implements OnInit, OnDestroy {
    @Input() data?: any;

    // #region public properties
    name = new UntypedFormControl('');
    URL = new UntypedFormControl('');
    webSites = new WebSites();
    title = 'New website';
    // #endregion

    // #region private properties
    private _isEdit = false;
    // #endregion

    // #region constructor
    constructor(
        private _store: Store<AppState>,
        private _slideSheetService: SlideSheetService,
    ) { }
    // #endregion

    // #region angular functions
    ngOnInit() {
        if (this.data) {
            this._isEdit = true;
            this.title = 'Edit website';
            this.webSites = _lodash.cloneDeep(this.data);
        } else {
            // init controls
            this._initControls();
        }
    }

    ngOnDestroy(): void {
    }
    // #endregion

    // #region public functions
    onSlideSheetClose() {
        this._slideSheetService.slideSheetActionSubject$.next({
            type: SlideSheetActionTypes.CLOSE
        });
    }

    /** Check the length of name. When the length of the name is valid, dispatches action to the store to create/edit object. */
    onSubmitClick() {
        if (this._isValid()) {
            const data = _lodash.cloneDeep(this.webSites);
            delete data['editable'];
            delete data['deletable'];
            delete data['type'];
            if (data['symbolFormatList'] && data['symbolFormatList'].length > 0) {
                data['symbolFormatList'] = data['symbolFormatList'].toString().split(',');
            } else {
                data['symbolFormatList'] = [];
            }
            if (this._isEdit) {
                this._store.dispatch({
                    type: AdminPageActionTypes.EDIT_SHARED_PAGE,
                    payload: {
                        type: adminSharedPageConstants['web-sites'].type,
                        key: 'webSiteConfig',
                        item: data
                    }
                });
            } else {
                this._store.dispatch({
                    type: AdminPageActionTypes.CREATE_SHARED_PAGE,
                    payload: {
                        type: adminSharedPageConstants['web-sites'].type,
                        key: 'webSiteConfig',
                        item: data
                    }
                });
            }
        }
    }
    // #endregion

    // #region private functions
    private _initControls() {
        this.webSites.ID = IdHelperService.createGUID(1);
        this.webSites.webSiteDialogAttributes = new WebSiteDialogAttributes();
        this.webSites.PDF_URL = '';
        this.webSites.tamaleAuthentication = false;
        this.webSites.editable = true;
        this.webSites.params = '';
        this.webSites.submitPDF = false;
        this.webSites.javascript = '';
    }

    private _isValid(): boolean {
        let isValid = true;

        this.name.setErrors(null);
        if (!this.name.value) {
            this.name.setErrors({
                required: true
            });
            isValid = false;
        } else if (this.name.value.length > 128) {
            this.name.setErrors({
                maxlength: true
            });
            isValid = false;
        }

        this.URL.setErrors(null);
        if (!this.URL.value) {
            this.URL.setErrors({
                required: true
            });
            isValid = false;
        }
        return isValid;
    }
    // #endregion
}
